export default __webpack_public_path__ + "assets/models/64a5f641037562294b9bd39e681c5964.glb";